// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LTuD","tabsBox":"styles_tabsBox__DbF5d","createButton":"styles_createButton__QrGT8"};